import React from "react";
import { SITE } from "../../config/site";

const ICONS = {
  x: (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <path
        fill="currentColor"
        d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.451-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z"
      />
    </svg>
  ),
  linkedin: (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <path
        fill="currentColor"
        d="M4.983 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm.02 6.75H3.03v10.25h1.973V10.25Zm3.443 0H6.5v10.25h1.946v-5.396c0-1.4.264-2.756 2-2.756 1.71 0 1.731 1.6 1.731 2.844V20.5H14.1v-5.958c0-2.99-.646-5.293-4.14-5.293-1.68 0-2.81.923-3.273 1.797h-.037V9.75h-.204Z"
      />
    </svg>
  ),
};

export default function SocialLinks({
  heading = "Follow Culmora OS",
  align = "left",
  testId = "social-links",
  showHeading = true,
}) {
  const links = [
    { id: "x", label: "Follow Culmora OS on X", href: SITE.xUrl },
    {
      id: "linkedin",
      label: "Follow Culmora OS on LinkedIn",
      href: SITE.linkedinUrl,
    },
  ].filter((link) => Boolean(link.href));

  if (links.length === 0) return null;

  return (
    <div data-testid={testId} className={align === "center" ? "text-center" : ""}>
      {showHeading && (
        <p className="text-[11px] uppercase tracking-[0.24em] text-[hsl(var(--z-text-soft))]">
          {heading}
        </p>
      )}
      <ul
        className={`${showHeading ? "mt-4" : ""} flex items-center gap-3 ${
          align === "center" ? "justify-center" : ""
        }`}
      >
        {links.map((link) => (
          <li key={link.id}>
            <a
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={link.label}
              data-testid={`social-${link.id}`}
              className="inline-flex items-center justify-center w-11 h-11 rounded-full border border-[hsl(var(--z-border-strong))] text-[hsl(var(--z-text-muted))] hover:text-[hsl(var(--z-teal))] hover:border-[hsl(var(--z-teal))] focus-visible:text-[hsl(var(--z-teal))] focus-visible:border-[hsl(var(--z-teal))] transition-colors"
            >
              {ICONS[link.id]}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
